import LiquidText, { liquidTone } from '../components/LiquidText';
import { LiquidDialog } from '../components/LiquidUI';
import DeleteIcon from '../components/DeleteIcon';
import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import AnexosSgiModal from '../components/AnexosSgiModal';

/* ============================================================
   GOVERNAÇÃO DO SGI — AUDITORIAS (9.2) E REVISÃO PELA GESTÃO (9.3)
   As NC/OM das auditorias tratam-se no módulo de Não Conformidades
   (origens "auditoria interna/externa" já existem lá).
   ============================================================ */

const AUD_TIPOS = {
    interna: 'Auditoria interna',
    externa_1fase: 'Externa — 1.ª fase (concessão)',
    externa_2fase: 'Externa — 2.ª fase (concessão)',
    acompanhamento: 'Externa — acompanhamento',
    cliente: 'Auditoria de cliente',
    outra: 'Outra',
};
const AUD_ESTADOS = {
    planeada: { label: 'Planeada', bg: '#e0f2fe', fg: '#075985' },
    realizada: { label: 'Realizada', bg: '#fef9c3', fg: '#854d0e' },
    fechada: { label: 'Fechada', bg: '#dcfce7', fg: '#166534' },
};
const fmtData = (d) => { if (!d) return '—'; try { return new Date(d).toLocaleDateString('pt-PT'); } catch { return '—'; } };

/* ---------- Auditoria (criar/editar) ---------- */
function AuditoriaModal({ auditoria, onClose, onSaved }) {
    const novo = !auditoria;
    const campos = ['tipo', 'data_inicio', 'data_fim', 'auditor', 'entidade', 'ambito', 'referencial', 'conclusoes', 'num_nc', 'num_om', 'relatorio_ref', 'estado', 'observacoes'];
    const [form, setForm] = useState(() => {
        const base = { tipo: 'interna', estado: 'planeada', num_nc: 0, num_om: 0 };
        campos.forEach(k => { base[k] = auditoria?.[k] ?? (base[k] ?? ''); });
        ['data_inicio', 'data_fim'].forEach(k => { if (auditoria?.[k]) base[k] = String(auditoria[k]).substring(0, 10); });
        return base;
    });
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');
    const upd = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

    const guardar = async () => {
        setSaving(true); setErr('');
        try {
            if (novo) await api.post('/sistema-integrado/auditorias', form);
            else await api.put(`/sistema-integrado/auditorias/${auditoria.id}`, form);
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar'); }
        finally { setSaving(false); }
    };

    return (
        <LiquidDialog data-sgi-dialog="true" onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 680 }} onClick={e => e.stopPropagation()}>
                <div data-sgi-dialog-heading="true" style={modalHead}>
                    <h3 style={{ margin: 0 }}>{novo ? 'Nova auditoria' : 'Editar auditoria'}</h3>
                    <button data-liquid-close="true" aria-label="Fechar" onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>
                <div style={grid3}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Tipo</label>
                        <select value={form.tipo} onChange={e => upd('tipo', e.target.value)} style={{ ...inp, width: '100%' }}>
                            {Object.entries(AUD_TIPOS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                        </select>
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Data início</label>
                        <input type="date" value={form.data_inicio} onChange={e => upd('data_inicio', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Data fim</label>
                        <input type="date" value={form.data_fim} onChange={e => upd('data_fim', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                </div>
                <div style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Auditor(es)</label>
                        <input value={form.auditor} onChange={e => upd('auditor', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Entidade (se externa)</label>
                        <input value={form.entidade} onChange={e => upd('entidade', e.target.value)} placeholder="ex.: APCER" style={{ ...inp, width: '100%' }} />
                    </div>
                </div>
                <div style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Âmbito</label>
                        <input value={form.ambito} onChange={e => upd('ambito', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Referencial</label>
                        <input value={form.referencial} onChange={e => upd('referencial', e.target.value)} placeholder="ex.: ISO 9001:2015 + ISO 45001:2019" style={{ ...inp, width: '100%' }} />
                    </div>
                </div>
                <div style={grid3}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>N.º NC</label>
                        <input type="number" min="0" value={form.num_nc} onChange={e => upd('num_nc', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>N.º OM</label>
                        <input type="number" min="0" value={form.num_om} onChange={e => upd('num_om', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Estado</label>
                        <select value={form.estado} onChange={e => upd('estado', e.target.value)} style={{ ...inp, width: '100%' }}>
                            {Object.entries(AUD_ESTADOS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
                        </select>
                    </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Conclusões</label>
                    <textarea value={form.conclusoes} onChange={e => upd('conclusoes', e.target.value)} rows={3} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Relatório (localização na rede)</label>
                    <input value={form.relatorio_ref} onChange={e => upd('relatorio_ref', e.target.value)} style={{ ...inp, width: '100%' }} />
                </div>
                <div style={{ marginBottom: 6 }}>
                    <label data-liquid-label="true" style={lbl}>Observações</label>
                    <textarea value={form.observacoes} onChange={e => upd('observacoes', e.target.value)} rows={2} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                {err && <div style={{ color: '#e53e3e', margin: '10px 0', fontSize: '0.85rem' }}>{err}</div>}
                <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
                    <button data-liquid-secondary="true" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={{ ...btnPri, opacity: saving ? 0.6 : 1 }}>{saving ? 'A guardar…' : 'Guardar'}</button>
                </div>
            </div>
        </LiquidDialog>
    );
}

/* ---------- Revisão pela gestão (criar/editar) ---------- */
function RevisaoModal({ revisao, onClose, onSaved }) {
    const novo = !revisao;
    const campos = ['data', 'participantes', 'assuntos', 'conclusoes', 'ata_ref', 'estado', 'observacoes'];
    const [form, setForm] = useState(() => {
        const base = { estado: 'realizada' };
        campos.forEach(k => { base[k] = revisao?.[k] ?? (base[k] ?? ''); });
        if (revisao?.data) base.data = String(revisao.data).substring(0, 10);
        return base;
    });
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');
    const upd = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

    const guardar = async () => {
        if (!form.data) { setErr('Indique a data.'); return; }
        setSaving(true); setErr('');
        try {
            if (novo) await api.post('/sistema-integrado/revisoes-gestao', form);
            else await api.put(`/sistema-integrado/revisoes-gestao/${revisao.id}`, form);
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar'); }
        finally { setSaving(false); }
    };

    return (
        <LiquidDialog data-sgi-dialog="true" onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 640 }} onClick={e => e.stopPropagation()}>
                <div data-sgi-dialog-heading="true" style={modalHead}>
                    <h3 style={{ margin: 0 }}>{novo ? 'Nova revisão pela gestão' : `Revisão de ${fmtData(revisao.data)}`}</h3>
                    <button data-liquid-close="true" aria-label="Fechar" onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>
                <div style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Data *</label>
                        <input type="date" value={form.data} onChange={e => upd('data', e.target.value)} style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Estado</label>
                        <select value={form.estado} onChange={e => upd('estado', e.target.value)} style={{ ...inp, width: '100%' }}>
                            <option value="planeada">Planeada</option>
                            <option value="realizada">Realizada</option>
                        </select>
                    </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Participantes</label>
                    <input value={form.participantes} onChange={e => upd('participantes', e.target.value)} style={{ ...inp, width: '100%' }} />
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Assuntos (entradas da revisão — 9.3.2)</label>
                    <textarea value={form.assuntos} onChange={e => upd('assuntos', e.target.value)} rows={3} style={{ ...inp, width: '100%', resize: 'vertical' }}
                        placeholder="Estado de ações anteriores, desempenho e indicadores, NC/AC, resultados de auditorias, consulta dos trabalhadores, adequação de recursos, oportunidades de melhoria…" />
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Conclusões / decisões (saídas — 9.3.3)</label>
                    <textarea value={form.conclusoes} onChange={e => upd('conclusoes', e.target.value)} rows={3} style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                <div style={{ marginBottom: 6 }}>
                    <label data-liquid-label="true" style={lbl}>Ata (localização na rede)</label>
                    <input value={form.ata_ref} onChange={e => upd('ata_ref', e.target.value)} style={{ ...inp, width: '100%' }} />
                </div>
                {err && <div style={{ color: '#e53e3e', margin: '10px 0', fontSize: '0.85rem' }}>{err}</div>}
                <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 14 }}>
                    <button data-liquid-secondary="true" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={{ ...btnPri, opacity: saving ? 0.6 : 1 }}>{saving ? 'A guardar…' : 'Guardar'}</button>
                </div>
            </div>
        </LiquidDialog>
    );
}

/* ---------- Planeamento e comunicação do SGI (RG.04) ---------- */
const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

function EvidenciaComModal({ linha, onClose, onSaved }) {
    const [form, setForm] = useState({ data_evidencia: '', titulo: '', observacoes: '' });
    const [ficheiro, setFicheiro] = useState(null);
    const [saving, setSaving] = useState(false);
    const [err, setErr] = useState('');

    const guardar = async () => {
        if (!ficheiro) { setErr('É obrigatório anexar um ficheiro.'); return; }
        setSaving(true); setErr('');
        try {
            const fd = new FormData();
            Object.entries(form).forEach(([k, v]) => fd.append(k, v ?? ''));
            fd.append('ficheiro', ficheiro);
            await api.post(`/plano-comunicacao/${linha.id}/evidencias`, fd,
                { headers: { 'Content-Type': 'multipart/form-data' } });
            onSaved(); onClose();
        } catch (e) { setErr(e.response?.data?.error || 'Erro ao guardar.'); }
        finally { setSaving(false); }
    };

    return (
        <LiquidDialog data-sgi-dialog="true" onClose={onClose} style={overlay} onClick={onClose}>
            <div style={{ ...modal, maxWidth: 560 }} onClick={e => e.stopPropagation()}>
                <div data-sgi-dialog-heading="true" style={modalHead}>
                    <div>
                        <h3 style={{ margin: 0, fontSize: '1.02rem' }}>Evidência da comunicação</h3>
                        <div style={{ fontSize: '0.84rem', color: '#64748b', marginTop: 3 }}>{linha.descricao}</div>
                    </div>
                    <button data-liquid-close="true" aria-label="Fechar" onClick={onClose} style={closeBtn}><LiquidText>✕</LiquidText></button>
                </div>
                <div style={grid2}>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Data</label>
                        <input type="date" value={form.data_evidencia}
                            onChange={e => setForm(p => ({ ...p, data_evidencia: e.target.value }))}
                            style={{ ...inp, width: '100%' }} />
                    </div>
                    <div>
                        <label data-liquid-label="true" style={lbl}>Ficheiro</label>
                        <input type="file" onChange={e => setFicheiro(e.target.files?.[0] || null)} style={{ ...inp, width: '100%' }} />
                    </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                    <label data-liquid-label="true" style={lbl}>Título</label>
                    <input value={form.titulo} onChange={e => setForm(p => ({ ...p, titulo: e.target.value }))}
                        placeholder="Ata da reunião de 12-03-2026" style={{ ...inp, width: '100%' }} />
                </div>
                <div style={{ marginBottom: 12 }}>
                    <label data-liquid-label="true" style={lbl}>Observações</label>
                    <textarea value={form.observacoes} rows={2}
                        onChange={e => setForm(p => ({ ...p, observacoes: e.target.value }))}
                        style={{ ...inp, width: '100%', resize: 'vertical' }} />
                </div>
                {err && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginBottom: 8 }}>{err}</div>}
                <div data-liquid-actions="true" style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <button data-liquid-secondary="true" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-primary="true" onClick={guardar} disabled={saving} style={btnPri}>{saving ? 'A guardar…' : 'Guardar'}</button>
                </div>
            </div>
        </LiquidDialog>
    );
}

function PlanoComunicacao() {
    const anoAtual = new Date().getFullYear();
    const [ano, setAno] = useState(anoAtual);
    const [linhas, setLinhas] = useState([]);
    const [anos, setAnos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modal, setModal] = useState(null);
    const [processo, setProcesso] = useState('');

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const [p, a] = await Promise.all([
                api.get('/plano-comunicacao', { params: { ano } }),
                api.get('/plano-comunicacao/anos').catch(() => ({ data: [] })),
            ]);
            setLinhas(p.data.linhas || []);
            setAnos(a.data || []);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, [ano]);
    useEffect(() => { carregar(); }, [carregar]);

    const abrir = async (ev) => {
        try {
            const r = await api.get(`/plano-comunicacao/evidencias/${ev.id}/ficheiro`, { responseType: 'blob' });
            const tipo = r.data.type || 'application/octet-stream';
            const url = window.URL.createObjectURL(new Blob([r.data], { type: tipo }));
            if (tipo.includes('pdf')) window.open(url, '_blank');
            else { const a = document.createElement('a'); a.href = url; a.download = ev.nome_original || 'documento'; a.click(); }
            setTimeout(() => window.URL.revokeObjectURL(url), 60000);
        } catch { alert('Não foi possível abrir.'); }
    };
    const apagarEv = async (ev) => {
        if (!window.confirm('Apagar esta evidência?')) return;
        try { await api.delete(`/plano-comunicacao/evidencias/${ev.id}`); carregar(); } catch { alert('Erro.'); }
    };

    const [aEditar, setAEditar] = useState(null);
    /* Apagar diz quantas evidências leva à frente: uma linha com provas
       anexadas não se apaga por engano sem se saber o que se está a perder. */
    const apagarLinha = async (l) => {
        const n = (l.evidencias || []).length;
        const aviso = n
            ? `Apagar esta linha do plano?\n\n"${(l.descricao || '').slice(0, 80)}"\n\nLeva ${n} evidência(s) à frente, ficheiros incluídos. Não há como voltar atrás.`
            : `Apagar esta linha do plano?\n\n"${(l.descricao || '').slice(0, 80)}"`;
        if (!window.confirm(aviso)) return;
        try { await api.delete(`/plano-comunicacao/${l.id}`); carregar(); }
        catch (e) { alert(e.response?.data?.error || 'Não foi possível apagar.'); }
    };

    const processos = [...new Set(linhas.map(l => l.processo).filter(Boolean))].sort();
    /* Marcar ou desmarcar um mês previsto.

       O PUT do plano reescreve a linha toda e converte campos vazios em nulos,
       por isso reenvia-se a linha inteira — mandar só os meses apagava o resto.
       A quadrícula muda logo e só depois se grava; falhando, volta atrás e
       avisa, para nunca ficar a mostrar um plano que o servidor não tem. */
    const [aGravar, setAGravar] = useState(null);
    const alternarMes = async (linha, mes) => {
        const atuais = (linha.meses || '').split(',').map(x => x.trim()).filter(Boolean);
        const novos = atuais.includes(mes)
            ? atuais.filter(x => x !== mes)
            : [...atuais, mes].sort((a, b) => MESES.indexOf(a) - MESES.indexOf(b));
        const texto = novos.join(',');
        const antes = linha.meses;
        setLinhas(ls => ls.map(l => (l.id === linha.id ? { ...l, meses: texto } : l)));
        setAGravar(linha.id);
        try {
            await api.put(`/plano-comunicacao/${linha.id}`, { ...linha, meses: texto });
        } catch (e) {
            setLinhas(ls => ls.map(l => (l.id === linha.id ? { ...l, meses: antes } : l)));
            alert('Não foi possível guardar o mês. A linha ficou como estava.');
        } finally { setAGravar(null); }
    };

    const visiveis = processo ? linhas.filter(l => l.processo === processo) : linhas;
    const comEvid = linhas.filter(l => (l.evidencias || []).length > 0).length;
    const mesAtual = new Date().getMonth();

    return (
        <div>
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 14 }}>
                <div>
                    <label data-liquid-label="true" style={lbl}>Ano</label>
                    <select value={ano} onChange={e => setAno(parseInt(e.target.value, 10))} style={inp}>
                        {[...new Set([...anos, anoAtual, anoAtual + 1])].sort((a, b) => b - a)
                            .map(a => <option key={a} value={a}>{a}{anos.includes(a) ? '' : ' (vazio)'}</option>)}
                    </select>
                </div>
                <div>
                    <label data-liquid-label="true" style={lbl}>Processo</label>
                    <select value={processo} onChange={e => setProcesso(e.target.value)} style={{ ...inp, maxWidth: 280 }}>
                        <option value="">Todos</option>
                        {processos.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                </div>
                <div style={{ flex: 1 }} />
                <div style={{ fontSize: '0.84rem', color: '#64748b' }}>
                    <strong style={{ color: comEvid ? '#166534' : '#b45309' }}>{comEvid}</strong> de {linhas.length} com evidência carregada
                </div>
            </div>

            {loading ? <p style={{ color: '#718096' }}>A carregar…</p> : linhas.length === 0 ? (
                <p style={{ color: '#94a3b8', padding: '10px 0' }}>Sem plano de comunicação para {ano}.</p>
            ) : (
                <div className="table-responsive" style={{ backgroundColor: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                    <table className="standard-table" style={{ fontSize: '0.85rem' }}>
                        <thead>
                            <tr>
                                <th>O que se comunica</th>
                                <th>Periodicidade</th>
                                <th>A quem</th>
                                <th>Como</th>
                                <th>Resp.</th>
                                <th style={{ textAlign: 'center' }}>Meses previstos</th>
                                <th>Evidências</th>
                                <th style={{ textAlign: 'right' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {visiveis.map(l => {
                                const meses = (l.meses || '').split(',').filter(Boolean);
                                const evs = l.evidencias || [];
                                return (
                                    <tr key={l.id}>
                                        <td style={{ fontWeight: 600, maxWidth: 260 }}>
                                            {(l.descricao || '').replace(/\n/g, ' ')}
                                            <div style={{ fontWeight: 400, fontSize: '0.76rem', color: '#94a3b8' }}>{l.processo}</div>
                                        </td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{(l.periodicidade || '—').replace(/\n/g, ' ')}</td>
                                        <td style={{ maxWidth: 180, fontSize: '0.8rem' }}>{(l.parte_interessada || '—').replace(/\n/g, ' ')}</td>
                                        <td style={{ maxWidth: 150, fontSize: '0.8rem' }}>{(l.forma || '—').replace(/\n/g, ' ')}</td>
                                        <td style={{ whiteSpace: 'nowrap', fontSize: '0.8rem' }}>{(l.responsavel || '—').replace(/\n/g, ' ')}</td>
                                        <td>
                                            {/* Doze quadrículas: o mês previsto fica marcado, e o mês
                                                corrente leva contorno para se ver o que está a acontecer agora. */}
                                            <div style={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
                                                {MESES.map((m, i) => {
                                                    const prev = meses.includes(m);
                                                    return (
                                                        <button key={m} type="button"
                                                            onClick={() => alternarMes(l, m)}
                                                            disabled={aGravar === l.id}
                                                            title={`${m} — ${prev ? 'previsto, clique para retirar' : 'clique para prever'}`}
                                                            aria-pressed={prev}
                                                            style={{
                                                                width: 14, height: 16, borderRadius: 2, fontSize: '0.55rem',
                                                                display: 'grid', placeItems: 'center', padding: 0,
                                                                border: 'none', cursor: aGravar === l.id ? 'wait' : 'pointer',
                                                                fontFamily: 'inherit',
                                                                background: prev ? '#c7d2fe' : '#f1f5f9',
                                                                color: prev ? '#3730a3' : '#94a3b8',
                                                                fontWeight: prev ? 700 : 400,
                                                                opacity: aGravar === l.id ? 0.5 : 1,
                                                                outline: (ano === anoAtual && i === mesAtual) ? '1.5px solid #6366f1' : 'none',
                                                            }}>{m[0]}</button>
                                                    );
                                                })}
                                            </div>
                                        </td>
                                        <td style={{ maxWidth: 230 }}>
                                            {/* Uma evidência pode ser um ficheiro anexado ou uma
                                                remissão para um registo que já vive noutro módulo
                                                — a revisão pela gestão, a avaliação de riscos. Nesse
                                                caso não há o que abrir: mostra-se a remissão. */}
                                            {evs.length === 0 ? <span style={{ color: '#cbd5e1' }}>—</span> : evs.map(ev => (
                                                <div key={ev.id} style={{ display: 'flex', gap: 5, alignItems: 'center', marginBottom: 2 }}>
                                                    {ev.nome_original ? (
                                                        <button onClick={() => abrir(ev)}
                                                            style={{ border: 'none', background: 'none', color: '#3182ce', cursor: 'pointer', padding: 0, fontSize: '0.8rem', textAlign: 'left' }}><LiquidText>
                                                            📎 </LiquidText>{ev.data_evidencia ? fmtData(ev.data_evidencia) : ''} {ev.titulo?.substring(0, 26)}
                                                        </button>
                                                    ) : (
                                                        <span title={ev.observacoes || ''}
                                                            style={{ color: '#475569', fontSize: '0.8rem' }}><LiquidText>
                                                            ↪ </LiquidText>{ev.data_evidencia ? fmtData(ev.data_evidencia) : ''} {ev.titulo?.substring(0, 26)}
                                                        </span>
                                                    )}
                                                    <button onClick={() => apagarEv(ev)} title="Apagar"
                                                        style={{ border: 'none', background: 'none', color: '#cbd5e1', cursor: 'pointer', fontSize: '0.7rem' }}><DeleteIcon /></button>
                                                </div>
                                            ))}
                                        </td>
                                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                            <button data-liquid-secondary="true" onClick={() => setModal(l)} style={{ ...btnSec, ...mini }}>+ Evidência</button>
                                            {' '}
                                            <button data-liquid-secondary="true" onClick={() => setAEditar(l)} title="Editar esta linha"
                                                style={{ ...btnSec, ...mini }}><LiquidText>✎</LiquidText></button>
                                            {' '}
                                            <button data-liquid-secondary="true" onClick={() => apagarLinha(l)} title="Apagar esta linha"
                                                style={{ ...btnSec, ...mini, color: '#b91c1c', borderColor: '#fecaca' }}><DeleteIcon /></button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {modal && <EvidenciaComModal linha={modal} onClose={() => setModal(null)} onSaved={carregar} />}
            {aEditar && <LinhaPlanoModal linha={aEditar} onClose={() => setAEditar(null)} onSaved={carregar} />}
        </div>
    );
}

/* A linha do plano, editável.

   Os meses não entram aqui: marcam-se na quadrícula da tabela, que é onde se
   veem ao lado das outras linhas. Repeti-los na janela dava dois sítios para
   fazer a mesma coisa — e dois sítios discordam mais cedo ou mais tarde. */
function LinhaPlanoModal({ linha, onClose, onSaved }) {
    const [f, setF] = useState({
        processo: linha.processo || '', descricao: linha.descricao || '',
        periodicidade: linha.periodicidade || '', parte_interessada: linha.parte_interessada || '',
        tipo: linha.tipo || '', forma: linha.forma || '',
        responsavel: linha.responsavel || '', execucao: linha.execucao || '',
        observacoes: linha.observacoes || '',
    });
    const [aGravar, setAGravar] = useState(false);
    const [erro, setErro] = useState('');
    const muda = (k) => (e) => setF(v => ({ ...v, [k]: e.target.value }));

    const gravar = async () => {
        if (!f.descricao.trim()) { setErro('O que se comunica é obrigatório.'); return; }
        setAGravar(true); setErro('');
        try {
            // A linha inteira, e não só o que mudou: o PUT reescreve tudo e
            // converte o que falta em nulos. Os meses vêm de linha para não
            // serem apagados por esta janela não os mostrar.
            await api.put(`/plano-comunicacao/${linha.id}`, { ...linha, ...f });
            onSaved(); onClose();
        } catch (e) { setErro(e.response?.data?.error || e.message); }
        finally { setAGravar(false); }
    };

    const campos = [
        ['descricao', 'O que se comunica', true],
        ['processo', 'Processo'],
        ['periodicidade', 'Periodicidade'],
        ['parte_interessada', 'A quem'],
        ['forma', 'Como'],
        ['responsavel', 'Responsável'],
        ['tipo', 'Tipo'],
        ['execucao', 'Execução'],
        ['observacoes', 'Observações', true],
    ];

    return (
        <div onClick={onClose}
            style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.45)', zIndex: 2000,
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div onClick={e => e.stopPropagation()}
                style={{ background: '#fff', borderRadius: 12, padding: '20px 22px', width: 620,
                    maxWidth: '94vw', maxHeight: '88vh', overflowY: 'auto' }}>
                <h3 style={{ margin: '0 0 14px', fontSize: '1.05rem' }}>Editar linha do plano</h3>
                {erro && <p style={{ color: '#b91c1c', fontSize: '0.85rem', margin: '0 0 10px' }}>{erro}</p>}
                {campos.map(([k, etiqueta, largo]) => (
                    <div key={k} style={{ marginBottom: 10 }}>
                        <label data-liquid-label="true" style={lbl}>{etiqueta}</label>
                        {largo ? (
                            <textarea value={f[k]} onChange={muda(k)} rows={k === 'descricao' ? 2 : 3}
                                style={{ ...inp, width: '100%', boxSizing: 'border-box', resize: 'vertical' }} />
                        ) : (
                            <input value={f[k]} onChange={muda(k)}
                                style={{ ...inp, width: '100%', boxSizing: 'border-box' }} />
                        )}
                    </div>
                ))}
                <div data-liquid-actions="true" style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 6 }}>
                    <button data-liquid-secondary="true" onClick={onClose} style={btnSec}>Cancelar</button>
                    <button data-liquid-secondary="true" onClick={gravar} disabled={aGravar}
                        style={{ ...btnSec, background: '#3182ce', color: '#fff', borderColor: '#3182ce' }}>
                        {aGravar ? 'A guardar…' : 'Guardar'}
                    </button>
                </div>
            </div>
        </div>
    );
}

/* ---------- Componente principal ---------- */
const Governacao = () => {
    const [auditorias, setAuditorias] = useState([]);
    const [modalAnexos, setModalAnexos] = useState(null);
    const [revisoes, setRevisoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalAud, setModalAud] = useState(null);
    const [modalRev, setModalRev] = useState(null);
    const [vista, setVista] = useState('orgaos'); // orgaos | comunicacao

    const carregar = useCallback(async () => {
        setLoading(true);
        try {
            const [a, r] = await Promise.all([
                api.get('/sistema-integrado/auditorias'),
                api.get('/sistema-integrado/revisoes-gestao'),
            ]);
            setAuditorias(a.data || []);
            setRevisoes(r.data || []);
        } catch (e) { console.error(e); }
        finally { setLoading(false); }
    }, []);
    useEffect(() => { carregar(); }, [carregar]);

    const elimAud = async (a) => {
        if (!window.confirm('Eliminar esta auditoria?')) return;
        try { await api.delete(`/sistema-integrado/auditorias/${a.id}`); carregar(); } catch { alert('Erro'); }
    };
    const elimRev = async (r) => {
        if (!window.confirm('Eliminar esta revisão?')) return;
        try { await api.delete(`/sistema-integrado/revisoes-gestao/${r.id}`); carregar(); } catch { alert('Erro'); }
    };

    if (vista === 'comunicacao') {
        return (
            <div>
                <div className="shared-subnav" style={{ marginBottom: 14 }}>
                    <button className="shared-subnav-btn" onClick={() => setVista('orgaos')}>Auditorias e Revisões</button>
                    <button className="shared-subnav-btn active">Planeamento e Comunicação (RG.04)</button>
                </div>
                <PlanoComunicacao />
            </div>
        );
    }

    return (
        <div>
            <div className="shared-subnav" style={{ marginBottom: 14 }}>
                <button className="shared-subnav-btn active">Auditorias e Revisões</button>
                <button className="shared-subnav-btn" onClick={() => setVista('comunicacao')}>Planeamento e Comunicação (RG.04)</button>
            </div>

            {/* Auditorias */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <h3 style={{ margin: 0, fontSize: '1.02rem', color: '#1e293b' }}><LiquidText>🔍 Auditorias (9.2)</LiquidText></h3>
                <button data-liquid-primary="true" onClick={() => setModalAud({})} style={btnPri}>+ Nova auditoria</button>
            </div>
            {loading ? <p style={{ color: '#718096' }}>A carregar…</p> : auditorias.length === 0 ? (
                <p style={{ color: '#94a3b8', padding: '10px 0 20px' }}>Sem auditorias registadas.</p>
            ) : (
                <div className="table-responsive" style={{ backgroundColor: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto', marginBottom: 24 }}>
                    <table className="standard-table">
                        <thead>
                            <tr>
                                <th>Tipo</th>
                                <th>Data</th>
                                <th>Auditor / entidade</th>
                                <th>Referencial</th>
                                <th style={{ textAlign: 'center' }}>NC</th>
                                <th style={{ textAlign: 'center' }}>OM</th>
                                <th style={{ textAlign: 'center' }}>Relatório</th>
                                <th>Estado</th>
                                <th style={{ textAlign: 'right' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {auditorias.map(a => {
                                const es = AUD_ESTADOS[a.estado] || AUD_ESTADOS.planeada;
                                return (
                                    <tr key={a.id}>
                                        <td style={{ fontWeight: 600 }}>{AUD_TIPOS[a.tipo] || a.tipo}</td>
                                        <td style={{ whiteSpace: 'nowrap' }}>{fmtData(a.data_inicio)}{a.data_fim ? ` → ${fmtData(a.data_fim)}` : ''}</td>
                                        <td>{[a.auditor, a.entidade].filter(Boolean).join(' · ') || '—'}</td>
                                        <td style={{ fontSize: '0.82rem' }}>{a.referencial || '—'}</td>
                                        <td style={{ textAlign: 'center', fontWeight: 700, color: a.num_nc ? '#991b1b' : '#166534' }}>{a.num_nc}</td>
                                        <td style={{ textAlign: 'center' }}>{a.num_om}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button onClick={() => setModalAnexos({ rota: 'auditorias', registo: a, etiqueta: `${AUD_TIPOS[a.tipo] || a.tipo} · ${fmtData(a.data_inicio)}` })}
                                                style={{ ...badge, border: 'none', cursor: 'pointer', background: (a.anexos || []).length ? '#dcfce7' : '#fee2e2', color: (a.anexos || []).length ? '#166534' : '#991b1b' }}
                                                title={(a.anexos || []).length ? a.anexos.map(x => x.titulo).join('\n') : 'Sem relatório anexo — o registo depende do caminho de rede'}>
                                                {(a.anexos || []).length ? `${a.anexos.length} anexo${a.anexos.length > 1 ? 's' : ''}` : 'em falta'}
                                            </button>
                                        </td>
                                        <td><span data-liquid-tone={liquidTone(es.bg)} data-liquid-badge="true" style={{ ...badge, background: es.bg, color: es.fg }}><LiquidText>{es.label}</LiquidText></span></td>
                                        <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                            <button data-liquid-secondary="true" onClick={() => setModalAud({ auditoria: a })} style={{ ...btnSec, ...mini }}>Editar</button>
                                            <button data-liquid-secondary="true" onClick={() => elimAud(a)} style={{ ...btnSec, ...mini, color: '#e53e3e' }}><LiquidText>✕</LiquidText></button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Revisão pela gestão */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <h3 style={{ margin: 0, fontSize: '1.02rem', color: '#1e293b' }}><LiquidText>🏛️ Revisão pela gestão (9.3)</LiquidText></h3>
                <button data-liquid-primary="true" onClick={() => setModalRev({})} style={btnPri}>+ Nova revisão</button>
            </div>
            {loading ? null : revisoes.length === 0 ? (
                <p style={{ color: '#94a3b8', padding: '10px 0' }}>Sem revisões registadas.</p>
            ) : (
                <div className="table-responsive" style={{ backgroundColor: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'auto' }}>
                    <table className="standard-table">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Participantes</th>
                                <th>Assuntos</th>
                                <th style={{ textAlign: 'center' }}>Ata</th>
                                <th>Estado</th>
                                <th style={{ textAlign: 'right' }}>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {revisoes.map(r => (
                                <tr key={r.id}>
                                    <td style={{ whiteSpace: 'nowrap', fontWeight: 600 }}>{fmtData(r.data)}</td>
                                    <td style={{ maxWidth: 240 }}>{r.participantes || '—'}</td>
                                    <td style={{ maxWidth: 340, fontSize: '0.85rem' }}>{(r.assuntos || '').substring(0, 140)}{(r.assuntos || '').length > 140 ? '…' : ''}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <button onClick={() => setModalAnexos({ rota: 'revisoes-gestao', registo: r, etiqueta: `Revisão de ${fmtData(r.data)}` })}
                                            style={{ ...badge, border: 'none', cursor: 'pointer', background: (r.anexos || []).length ? '#dcfce7' : '#fee2e2', color: (r.anexos || []).length ? '#166534' : '#991b1b' }}
                                            title={(r.anexos || []).length ? r.anexos.map(x => x.titulo).join('\n') : 'Sem ata anexa — o registo depende do caminho de rede'}>
                                            {(r.anexos || []).length ? `${r.anexos.length} anexo${r.anexos.length > 1 ? 's' : ''}` : 'em falta'}
                                        </button>
                                    </td>
                                    <td><span data-liquid-tone={liquidTone(r.estado === 'realizada' ? '#dcfce7' : '#e0f2fe')} data-liquid-badge="true" style={{ ...badge, background: r.estado === 'realizada' ? '#dcfce7' : '#e0f2fe', color: r.estado === 'realizada' ? '#166534' : '#075985' }}>{r.estado === 'realizada' ? 'Realizada' : 'Planeada'}</span></td>
                                    <td style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                                        <button data-liquid-secondary="true" onClick={() => setModalRev({ revisao: r })} style={{ ...btnSec, ...mini }}>Editar</button>
                                        <button data-liquid-secondary="true" onClick={() => elimRev(r)} style={{ ...btnSec, ...mini, color: '#e53e3e' }}><LiquidText>✕</LiquidText></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {modalAud && <AuditoriaModal auditoria={modalAud.auditoria} onClose={() => setModalAud(null)} onSaved={carregar} />}
            {modalRev && <RevisaoModal revisao={modalRev.revisao} onClose={() => setModalRev(null)} onSaved={carregar} />}
            {modalAnexos && <AnexosSgiModal {...modalAnexos} onClose={() => setModalAnexos(null)} onMudou={carregar} />}
        </div>
    );
};

/* ---------- estilos ---------- */
const lbl = { display: 'block', fontSize: '0.74rem', color: '#64748b', fontWeight: 600, marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.03em' };
const inp = { padding: '7px 10px', border: '1px solid #cbd5e1', borderRadius: 8, fontSize: '0.9rem', boxSizing: 'border-box' };
const badge = { padding: '3px 10px', borderRadius: 12, fontSize: '0.78rem', fontWeight: 600, whiteSpace: 'nowrap' };
const btnSec = { padding: '7px 14px', border: '1px solid #cbd5e1', background: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', color: '#334155' };
const btnPri = { padding: '7px 14px', border: '1px solid #3182ce', background: '#3182ce', color: '#fff', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem' };
const mini = { padding: '4px 9px', marginLeft: 6, fontSize: '0.76rem' };
const overlay = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, padding: '40px 16px', overflowY: 'auto' };
const modal = { background: '#fff', borderRadius: 14, padding: 22, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)' };
const modalHead = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 };
const closeBtn = { border: 'none', background: 'transparent', fontSize: '1.2rem', cursor: 'pointer', color: '#64748b' };
const grid2 = { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 };
const grid3 = { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 10 };

export default Governacao;
